<template>
	<div>
		<Header />
		<Gallery />
		<Footer />
	</div>
</template>

<script>

import Header from './Header.vue'
import Gallery from './Gallery.vue'
import Footer from '../../components/Footer.vue'

export default {
	name: 'Index',
	components: { Header, Gallery, Footer },
	created: function() {
	}
}
</script>
